import { render } from "./D1PTable.vue?vue&type=template&id=776d48e6&scoped=true"
import script from "./D1PTable.vue?vue&type=script&lang=js"
export * from "./D1PTable.vue?vue&type=script&lang=js"

import "./D1PTable.vue?vue&type=style&index=0&id=776d48e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776d48e6"]])

export default __exports__